import VTooltip from 'v-tooltip'
import Vue from 'vue'
import VueMq from 'vue-mq'

import App from '@ss/App.vue'
import router from '@ss/router'
import store from '@ss/store'

import moment from 'moment'
import { singular } from 'pluralize'

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.use(VTooltip, {
	popover: {
		defaultHandleResize: false,
		defaultDelay: {
			show: 0,
			hide: 100
		}
	}
})

Vue.use(VueMq, {
	breakpoints: {
		// default breakpoints - customize this
		mobile: 600,
		md: 800,
		lg: 1000,
		xl: Infinity
	},
	defaultBreakpoint: 'sm' // customize this for SSR
})

window.debounce = function (fn, delay, immediate) {
	let timeoutID = null
	return function (...args) {
		const later = () => {
			timeoutID = null
			if (!immediate) {
				fn.apply(this, args)
			}
		}
		const callNow = immediate && !timeoutID
		clearTimeout(timeoutID)
		timeoutID = setTimeout(later, delay)
		if (callNow) {
			fn.apply(this, args)
		}
	}
}

window.app = new Vue({
	router,
	store,
	data() {
		return {
			tours: {
				app: []
			},
			clientWidth: 0
		}
	},
	computed: {
		body() {
			return document.querySelector('body')
		},
		serverId() {
			return this.$store.state.app.env
		},
		isProduction() {
			return this.serverId === 'production'
		},
		isStaging() {
			return this.serverId === 'staging'
		},
		platform() {
			return 'social-stoke'
		},
		isMobile(): boolean {
			return this.clientWidth < 600
		},
		isPrintMode(): boolean {
			return this.$route.query.print === 'true'
		}
	},
	beforeMount() {
		this.$store.commit('app/SET_SERVICE', 'social-stoke')
	},
	mounted() {
		window.onresize = this.onClientResize
		this.onClientResize()
	},
	methods: {
		compactNumber: n => {
			if (n < 1e3) return Math.max(Math.round(n), 0)
			if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + 'K'
			if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + 'M'
			if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + 'B'
			if (n >= 1e12) return +(n / 1e12).toFixed(1) + 'T'
		},
		secondsToTime(seconds: number): string {
			const duration = moment.duration(seconds, 'seconds')
			const { years, months, days, hours, minutes } = (duration as any)._data
			return `${years ? `${years}y ` : ''}${months ? `${months}m ` : ''}${
				days ? `${days}d ` : ''
			}${hours ? `${hours}h ` : ''}${minutes ? `${minutes}m` : ''}`
		},
		open: (link): void => {
			window.open(link)
		},
		scrollTo(position, smooth = true) {
			this.$nextTick(() => {
				;(document.querySelector('.app-content') || window).scrollTo({
					left: 0,
					top: position,
					behavior: smooth ? 'smooth' : 'auto'
				})
			})
		},
		onClientResize() {
			this.clientWidth = Math.max(
				document.body.offsetWidth,
				document.documentElement.offsetWidth,
				document.documentElement.clientWidth
			)
		},
		getScrollElement() {
			return document.querySelector('.app-content')
		},
		callAppMethod(method, args) {
			try {
				return this.$children[0][method](args)
			} catch (e) {
				return e
			}
		},
		copyToClipboard(text) {
			const el = document.createElement('textarea')
			el.value = text
			document.body.appendChild(el)
			el.select()
			document.execCommand('copy')
			document.body.removeChild(el)
		},
		singularize(str) {
			return singular(str)
		},
		error(msg) {
			alert(msg)
		},
		success(msg) {
			this.$store.commit('app/setStatusMessage', msg)
		}
	},
	render: h => h(App)
}).$mount('#app')
